// extracted by mini-css-extract-plugin
export default {"wrap":"LocationBody_wrap__Z+bRx","text":"LocationBody_text__n08n0"};